import Html2Canvas from "html2canvas"

var appElement = null;
var captureImage = "";
var captureName = "";

/**
 * Capture: Provide global `$capture` to capture screenshots and `$download` to download most recent one
 */
export default {
    install (Vue, options) {
        Vue.prototype.$setAppElement = function(element) {
            return setAppElement(element);
        },
        Vue.prototype.$capture = function(filename) {
            return capture(filename);
        },
        Vue.prototype.$captureElement = function(filename, element) {
            return captureElement(filename, element);
        },
        Vue.prototype.$download = function() {
            return download();
        },
        Vue.prototype.$captureAndDownload = function(filename) {
            return captureAndDownload(filename);
        },
        Vue.prototype.$downloadAccessible = function(filename, text) {
            return downloadAccessible(filename, text);
        }
    }
}

/**
 * @param element to be captured -- will capture all child elements
 */
function setAppElement(element){
    appElement = element;
}

/**
 * @description wrapper for capture + download
 * @param filename name of file to download
 */
async function captureAndDownload(filename){
    await capture(filename);
    download();
}

/**
 * @description captures screenshot of base app element and converts it to image file
 * @param filename name of file to download later
 * @returns converted image file
 */
async function capture(filename){
    await captureElement(filename, appElement);
}

/**
 * @description captures screenshot and converts it to image file
 * @param filename name of file to download later
 * @returns converted image file
 */
async function captureElement(filename, element){
    if (element){
        captureName = filename;
        var canvas = await Html2Canvas(element, {backgroundColor: "#000000", allowCORS : true } );
        var image = canvas.toDataURL("image/jpg");
        captureImage = image;
        return image;
    }
    else {
        console.log("ERROR: element does not exist");
        return null;
    }
}

/**
 * @description downloads captureImage to file named captureName if both exist
 */
function download(){
    if (captureImage === ""){
        console.log("ERROR: no image saved for download")
    }
    else if (captureName === ""){
        console.log("ERROR: captured file is not named, will not download.")
    }
    else {
        const url = captureImage;
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', captureName);
        document.body.appendChild(link)
        link.click();
    }
}

function downloadAccessible(filename, text){
    const link = document.createElement('a');
    link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    link.setAttribute('download', filename);
  
    link.style.display = 'none';
    document.body.appendChild(link);
  
    link.click();
  
    document.body.removeChild(link);
}
